import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/** Fetch a single project by ID (for labels, breadcrumbs, filter pills, etc.) */
export const useProject = (projectId?: string) => {
  return useQuery({
    queryKey: ['project', projectId],
    enabled: !!projectId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('id, name, icon, scope_type, instructions')
        .eq('id', projectId!)
        .single();
      if (error) throw error;
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
